export enum CheckpointStatus {
  Completed = 'completed',
  Unattempted = 'unattempted',
}

export enum BadgeName {
  Aroundthegreen = 'aroundthegreen',
  Fullswing = 'fullswing',
  Knowledge = 'knowledge',
  Mastery = 'mastery',
  Putting = 'putting',
}
